import { ReactNode } from 'react'
import styled from 'styled-components'

const Item = styled.div`
    box-sizing: content-box;
    cursor: pointer;
    display: flex;
    height: 24px;
    line-height: 24px;
    padding: 6px 0;
    transition: color 0.1s ease-out;
    width: 100%;

    &:hover {
        color: #fff;
        font-weight: bold;
    }
`

const IconWrapper = styled.div`
    align-items: center;
    display: flex;
    height: 24px;
    justify-content: center;
    margin-left: auto;
    width: 24px;

    svg {
        display: block;
        width: 100%;
    }
`

type Props = {
    children?: ReactNode
    label: string
    onClick: () => void
}

const MenuItem = ({ children, label, onClick }: Props) => {
    return (
        <Item onClick={onClick}>
            <span>{label}</span>
            <IconWrapper>{children}</IconWrapper>
        </Item>
    )
}

export default MenuItem
